import { skipToken, useQuery } from '@apollo/client/react';
import { PersonalOfferFormValuesDocument } from 'graphql/generated/graphql';

const useExpressLoanPersonalOfferFormValues = ({ id }: { id?: string | null }) => {
  const { loading, error, data } = useQuery(
    PersonalOfferFormValuesDocument,
    // Skipped without an id.
    id ? { variables: { id }, fetchPolicy: 'cache-and-network' } : skipToken,
  );
  return { loading, error, formValues: data?.expressLoan?.personal_offer_form_values };
};

export default useExpressLoanPersonalOfferFormValues;
